import { takeEvery, put, call, delay, select } from 'redux-saga/effects'
import { push } from 'redux-first-history'
import {
  GET_INVOICES_START,
  API_SERVER,
  SAVE_AND_SEND_INVOICE,
  COPY_INVOICE,
  REMOVE_INVOICE,
  SAVE_INVOICE_DRAFT,
  EDIT_INVOICE,
  CANCEL_EDIT_INVOICE,
  GET_FINVOICE_OPERATOR,
  GENERATE_INVOICE_PDF,
  INVOICE_DOWNLOAD_PDF,
  SAVE_AND_SEND_INVOICE_PDF,
  LOCATION_CHANGE,
  NAVIGATE_TO_UPDATE_BANK_INFO,
  REMINDER_INVOICE_DOWNLOAD_PDF,
  CHANGE_VAT_PERCENT,
  SELECT_INVOICE_CUSTOMER,
  EDIT_AND_GO_TO_INVOICE,
  GO_TO_INVOICE,
  ADD_EXPENSES_TO_INVOICE,
  ADD_ALLOWANCES_TO_INVOICE,
  ADD_CREDIT_NOTE_INVOICE,
  GET_REGISTERED_USERS_LIST,
  GET_INVOICE_USER_EMAIL,
  ATTACH_WORKSHIFT_JOURNAL_ID,
  UPDATE_ATTACH_JOURNAL_TO_INVOICE
} from '../constants'
import {
  getInvoicesSuccess,
  getInvoicesFailed,
  saveInvoiceSuccess,
  saveAndSendInvoiceSuccess,
  reviewInvoiceEditSuccess,
  reviewInvoiceEditSendSuccess,
  updateInvoiceFailed,
  saveInvoiceFailed,
  getOperatorSuccess,
  getOperatorFailed,
  saveAndSendInvoice,
  getInvoiceByIdSuccess,
  copyInvoiceSuccess,
  generateInvoicePDFSuccess,
  generateInvoicePDFFailed,
  cancelEditInvoice,
  getProfessionSuccess,
  getProfessionFailed,
  loadProfileSuccess,
  saveInvoiceDraft,
  loadInvoiceItems,
  closeLoadInvoiceItems,
  closeInvoiceReviewSnackBar,
  getInvoicesStart,
  removeInvoiceAttachments,
  goToInvoice,
  addCreditNoteSuccess,
  setOriginalInvoiceId,
  addCreditNoteFailed,
  getRegisteredUsersListSuccess,
  getRegisteredUsersListFailed,
  getInvoiceUserEmail,
  attachWorkshiftJournalIdSuccess,
  updateAttachJournalToInvoiceFailed,
  updateAttachJournalToInvoice,
  updateAttachJournalToInvoiceSuccess,
  showInvoiceFormDialog,
  resetInvoices
} from '../actions/index'
import { apiManualPost, apiManualRequest, apiBlobPost } from '../utils/request'
import { propertyArray } from '../utils/invoice.utils'
import store from '../store'
import { updateFormValues, resetForm, setFieldValue, isEmpty } from '../form'
import {
  defaultValues,
  invoiceRowDefaultValues
} from '../components/invoice/invoiceForm.component'
import { calculateTotalSum } from '../utils/invoice.utils'
import { scrollToTop } from '../utils/scrollTo'
import { formatInvoiceFormValues } from '../utils/formatFormValues.utils'
import {
  getAttachedWorkShiftJournalIds,
  getInvoiceEdit,
  getRegisteredUsersList
} from '../selectors/invoice.selector'
import {
  getNavigateToUpdateBankInfo,
  getAttachments,
  getAttachedJournalPdfData
} from '../selectors/invoiceReviews.selector'
import { getSelectedUser } from '../selectors/adminUser.selector'
import {
  getUuid,
  getUserType,
  getLoggedInEmail
} from '../selectors/client.selector'
import i18next from 'i18next'
import {
  extractCostTranslation,
  convertCostsToi18next
} from '../utils/translations.utils'
import { convertGroupInvoiceRowValues } from '../utils/formatFormValues.utils'
import { stringToArray } from '../utils/employer/stringArrayHandle.utils'

/**
 * @author Pragya Gupta
 */

function* getInvoiceSaga({ data }) {
  const selectedUser = data
  try {
    const invoiceUrl = `${API_SERVER}/GetInvoices`
    const customerUrl = `${API_SERVER}/GetCustomers`

    const uuid = store.getState().client.user.data[2]

    const userType = store.getState().client.user.data[5]

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const invoiceResult = yield call(apiManualPost, invoiceUrl, body)
    const customerResult = yield call(apiManualPost, customerUrl, body)
    // yield put(openInvoiceFormDialog())
    if (invoiceResult.data.status === true && customerResult.data)
      yield put(
        getInvoicesSuccess(invoiceResult.data.data, customerResult.data)
      )
  } catch (e) {
    yield put(getInvoicesFailed(e))
  }
}

function* saveAndSendInvoiceSaga({ formValues }) {
  try {
    const uuid = yield select(getUuid)
    const userType = yield select(getUserType)
    const loggedInEmail = yield select(getLoggedInEmail)
    const selectedUser = yield select(getSelectedUser)
    const invoiceEdit = yield select(getInvoiceEdit)
    const attachments = yield select(getAttachments)
    const attachedJournalPdfData = yield select(getAttachedJournalPdfData)
    const registeredUsersList = yield select(getRegisteredUsersList)
    const attachedWorkShiftJournalIds = yield select(
      getAttachedWorkShiftJournalIds
    )

    let url
    let invoice_id
    let attachedWorkShiftJournalIds_old_value = []

    if (invoiceEdit.length > 0) {
      invoice_id = invoiceEdit[0].Invoice[0].invoice_id
      attachedWorkShiftJournalIds_old_value =
        store.getState().form.invoice.loadData?.attachedJournalIds
      if (attachedWorkShiftJournalIds_old_value === undefined) {
        attachedWorkShiftJournalIds_old_value = []
      }
    }

    url = `${API_SERVER}/SendInvoice`

    const normalInvoiceRow = formValues.rows.filter(
      (el) => el.invoice_expense_id === -1 && el.invoice_allowance_id === -1
    )

    formValues.vat_select =
      formValues.vat_selection === 25.5
        ? 'vat_25_5_common'
        : formValues.vat_selection === 24
        ? 'vat_24_common'
        : formValues.vat_selection === 'building_service'
        ? 'vat_0_builders'
        : formValues.vat_selection === 14
        ? 'vat_14_restaurants'
        : formValues.vat_selection === 10
        ? 'vat_10_sports'
        : formValues.vat_selection === 0
        ? 'vat_0_artists'
        : formValues.vat_selection === 'vat_abroad'
        ? 'vat_0_abroad'
        : normalInvoiceRow[0].vat_percent

    const bodyFormatted = formatInvoiceFormValues(
      formValues,
      uuid,
      userType,
      loggedInEmail,
      selectedUser,
      invoice_id,
      registeredUsersList,
      attachments,
      attachedWorkShiftJournalIds,
      attachedJournalPdfData
    )

    const invoiceLang = bodyFormatted.Invoice[0].invoice_lang

    // Take the user uuid, if admin user sending
    bodyFormatted.Invoice[0].uuid = userType == 2 ? selectedUser.uuid : uuid

    bodyFormatted.Invoice[0].rows = extractCostTranslation(
      i18next.t,
      bodyFormatted.Invoice[0].rows,
      invoiceLang
    )

    // Attached journal id
    const selectedJournalIds =
      attachedWorkShiftJournalIds === '' ? [] : attachedWorkShiftJournalIds
    // Detach value
    const detachedWorkShiftJournalIds =
      attachedWorkShiftJournalIds_old_value.filter(
        (id) => !selectedJournalIds.includes(id)
      )

    yield put(reviewInvoiceEditSendSuccess())

    const result = yield call(apiManualPost, url, JSON.stringify(bodyFormatted))
    /**
     * Possible result errors
     * - Missing field/s
     * - DBError
     * - Added invoice sum is lesser than expense and allowance sum
     * - Email sending failed
     * - Sending e-invoice failed
     * - Creating e-invoice failed
     * - Generating PDF failed
     * - APIError
     *
     *
     */

    if (result.data.message.includes('Invoice Pdf sent successfully')) {
      yield put(resetInvoices()) // Reset before refetching with updated status
      yield put(generateInvoicePDFSuccess(result.data.status))

      const pattern = /Invoice id is (\d+)$/
      const match = result.data.message.match(pattern)
      const invoiceId = match ? match[1] : null

      for (const value of selectedJournalIds) {
        yield put(
          updateAttachJournalToInvoice(
            value,
            invoiceEdit.length > 0 ? invoice_id : invoiceId,
            'add_to_invoice'
          )
        )
      }
      for (const value of detachedWorkShiftJournalIds) {
        yield put(
          updateAttachJournalToInvoice(
            value,
            invoiceEdit.length > 0 ? invoice_id : invoiceId,
            'detached_from_invoice'
          )
        )
      }
    } else if (
      result.data.message ===
      'Added invoice sum is lesser than expense and allowance sum'
    ) {
      yield put(updateInvoiceFailed())
    } else {
      const resultParsed = JSON.parse(result.data)
      yield put(saveAndSendInvoiceSuccess(resultParsed[0].invoice_id))
      for (const value of selectedJournalIds) {
        yield put(
          updateAttachJournalToInvoice(
            value,
            invoiceEdit.length > 0 ? invoice_id : resultParsed[0].invoice_id,
            'add_to_invoice'
          )
        )
      }
      for (const value of detachedWorkShiftJournalIds) {
        yield put(
          updateAttachJournalToInvoice(
            value,
            invoiceEdit.length > 0 ? invoice_id : resultParsed[0].invoice_id,
            'detached_from_invoice'
          )
        )
      }
      yield put(generateInvoicePDFFailed(result.data))
    }
  } catch (e) {
    yield put(saveInvoiceFailed())
    yield put(cancelEditInvoice())
  }
}

function* saveInvoiceDraftSaga({ formValues }) {
  try {
    const uuid = yield select(getUuid)
    const userType = yield select(getUserType)
    const loggedInEmail = yield select(getLoggedInEmail)
    const selectedUser = yield select(getSelectedUser)
    const invoiceEdit = yield select(getInvoiceEdit)
    const registeredUsersList = yield select(getRegisteredUsersList)
    const attachedWorkShiftJournalIds = yield select(
      getAttachedWorkShiftJournalIds
    )

    let url
    let invoice_id
    let attachedWorkShiftJournalIds_old_value = []

    if (invoiceEdit.length > 0) {
      invoice_id = invoiceEdit[0].Invoice[0].invoice_id
      if (!!invoice_id) {
        url = `${API_SERVER}/UpdateInvoice`
      }
      attachedWorkShiftJournalIds_old_value =
        store.getState().form.invoice.loadData?.attachedJournalIds
      if (attachedWorkShiftJournalIds_old_value === undefined) {
        attachedWorkShiftJournalIds_old_value = []
      }
    } else if (invoiceEdit.length <= 0) {
      url = `${API_SERVER}/AddInvoice`
    }

    const normalInvoiceRow = formValues.rows.filter(
      (el) => el.invoice_expense_id === -1 && el.invoice_allowance_id === -1
    )

    formValues.vat_select =
      formValues.vat_selection === 25.5
        ? 'vat_25_5_common'
        : formValues.vat_selection === 24
        ? 'vat_24_common'
        : formValues.vat_selection === 'building_service'
        ? 'vat_0_builders'
        : formValues.vat_selection === 14
        ? 'vat_14_restaurants'
        : formValues.vat_selection === 10
        ? 'vat_10_sports'
        : formValues.vat_selection === 0
        ? 'vat_0_artists'
        : formValues.vat_selection === 'vat_abroad'
        ? 'vat_0_abroad'
        : normalInvoiceRow[0].vat_percent

    const bodyFormatted = formatInvoiceFormValues(
      formValues,
      uuid,
      userType,
      loggedInEmail,
      selectedUser,
      invoice_id,
      registeredUsersList,
      null,
      attachedWorkShiftJournalIds
    )
    // '/AddInvoice' or '/UpdateInvoice' with draft status
    bodyFormatted.Invoice[0].status = 0
    // Take the user uuid, if admin user saving as draft
    bodyFormatted.Invoice[0].uuid = userType == 2 ? selectedUser.uuid : uuid

    const invoiceLang = bodyFormatted.Invoice[0].invoice_lang

    bodyFormatted.Invoice[0].rows = extractCostTranslation(
      i18next.t,
      bodyFormatted.Invoice[0].rows,
      invoiceLang
    )

    // journal id
    const selectedJournalIds =
      attachedWorkShiftJournalIds === '' ? [] : attachedWorkShiftJournalIds
    // Detach value
    const detachedWorkShiftJournalIds =
      attachedWorkShiftJournalIds_old_value.filter(
        (id) => !selectedJournalIds.includes(id)
      )

    const result = yield call(apiManualPost, url, JSON.stringify(bodyFormatted))

    const navigateToUpdateBankInfo = yield select(getNavigateToUpdateBankInfo)

    if (result.data === 'Invoice updated successfully') {
      yield put(reviewInvoiceEditSuccess())
      for (const value of selectedJournalIds) {
        yield put(
          updateAttachJournalToInvoice(value, invoice_id, 'add_to_invoice')
        )
      }
      for (const value of detachedWorkShiftJournalIds) {
        yield put(
          updateAttachJournalToInvoice(
            value,
            invoice_id,
            'detached_from_invoice'
          )
        )
      }
    } else if (
      result.data ===
      'Added invoice sum is lesser than expense and allowance sum'
    ) {
      yield put(updateInvoiceFailed())
    } else {
      const resultParsed = JSON.parse(result.data)
      yield put(saveInvoiceSuccess(resultParsed[0].invoice_id))
      if (selectedJournalIds.length > 0) {
        for (const value of selectedJournalIds) {
          yield put(
            updateAttachJournalToInvoice(
              value,
              resultParsed[0].invoice_id,
              'add_to_invoice'
            )
          )
        }
      }
      if (navigateToUpdateBankInfo) {
        yield put(closeInvoiceReviewSnackBar())
      }
    }
  } catch (e) {
    // console.warn(e)
    yield put(saveInvoiceFailed(e))
    yield put(cancelEditInvoice())
  }
}

function* saveAndSendInvoicePDF({ formValues }) {
  yield put(saveAndSendInvoice(formValues))
}

function* generateInvoicePDF({ invoice_id }) {
  try {
    const url = `${API_SERVER}/GenerateInvoicePDF`
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })
    yield call(apiManualPost, url, body)
  } catch (e) {
    // console.warn(e)
  }
}

function* invoiceDownloadPDF({ invoice_id }) {
  try {
    const url = `${API_SERVER}/InvoiceDownloadPDF`
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]

    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      remindersent: 0
    })
    yield call(apiBlobPost, url, body)
  } catch (e) {
    // console.warn(e)
  }
}

function* addCreditNoteInvoice({ invoice_id }) {
  try {
    const url = `${API_SERVER}/AddCreditNoteInvoice`
    const uuid = store.getState().client.user.data[2]
    const loggedInEmail = yield select(getLoggedInEmail)
    const userType = store.getState().client.user.data[5]

    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      userEmail: userType == 2 ? selectedUser.email : loggedInEmail,
      remindersent: 0
    })

    const result = yield call(apiManualPost, url, body)

    if (result.data) {
      const invoiceResult = JSON.parse(result.data)

      invoiceResult[0].Invoice[0].rows = convertCostsToi18next(
        invoiceResult[0].Invoice[0].rows
      )

      yield put(addCreditNoteSuccess(result.data))
      yield put(loadInvoiceItems())
      let creditNoteFromInvoice =
        invoiceResult[0].Invoice[0].credit_note_from_invoice
      if (creditNoteFromInvoice && creditNoteFromInvoice > 1) {
        yield put(setOriginalInvoiceId(creditNoteFromInvoice))
      }

      const formData = getFormData(
        invoiceResult,
        invoiceResult[0].Invoice[0].rows
      )
      formData.is_credit_note = true
      formData.quick_pay = false
      formData.groupInvoiceRow = []

      const normalInvoiceRow = formData.rows.filter(
        (el) => el.invoice_expense_id === -1 && el.invoice_allowance_id === -1
      )

      formData.vat_selection =
        formData.vat_select === 'vat_25_5_common'
          ? 25.5
          : formData.vat_select === 'vat_24_common'
          ? 24
          : formData.vat_select === 'vat_0_builders'
          ? 'building_service'
          : formData.vat_select === 'vat_14_restaurants'
          ? 14
          : formData.vat_select === 'vat_10_sports'
          ? 10
          : formData.vat_select === 'vat_0_artists'
          ? 0
          : formData.vat_select === 'vat_0_abroad'
          ? 'vat_abroad'
          : normalInvoiceRow[0].vat_percent

      if (invoiceResult[0].Invoice[0].is_group_invoice === 0) {
        formData.groupInvoiceRow = groupInvoiceRowDefaultValue
      }

      yield put(updateFormValues('invoice', formData))
      yield put(getInvoicesStart())
      yield put(closeLoadInvoiceItems())
    } else {
      yield put(addCreditNoteFailed())
      yield put(closeLoadInvoiceItems())
    }
  } catch (e) {
    yield put(addCreditNoteFailed())
    yield put(closeLoadInvoiceItems())
  }
}

function* reminderInvoiceDownloadPDF({ invoice_id }) {
  try {
    const url = `${API_SERVER}/InvoiceDownloadPDF`
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]

    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      remindersent: 1
    })
    yield call(apiBlobPost, url, body)
  } catch (e) {
    // console.warn(e)
  }
}

function* removeInvoiceSaga({ invoice_id, attached_journal_id }) {
  try {
    const url = `${API_SERVER}/DeleteInvoice`
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const isEdit = store.getState().invoice.isEdit
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })
    yield call(apiManualPost, url, body)

    if (attached_journal_id !== null) {
      const convert_attached_journal_id = stringToArray(attached_journal_id)
      for (const value of convert_attached_journal_id) {
        yield put(
          updateAttachJournalToInvoice(
            value,
            invoice_id,
            'detached_from_invoice'
          )
        )
      }
    }

    if (isEdit) {
      const invoiceEdit = store.getState().invoice.invoiceEdit
      const invoiceInEditMode = invoiceEdit[0].Invoice[0].invoice_id
      if (invoiceInEditMode === invoice_id) {
        yield put(cancelEditInvoice())
      }
    }
  } catch (e) {
    // console.log(e)
  }
}

// Group invoice row default value
const groupInvoiceRowDefaultValue = [
  {
    groupEmail: '',
    groupAmount: ''
  },
  {
    groupEmail: '',
    groupAmount: ''
  }
]

function* editInvoiceSaga({ invoice_id, expenses }) {
  try {
    yield put(loadInvoiceItems())

    const url = `${API_SERVER}/GetInvoiceByInvoiceID`
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const registeredUsersList = store.getState().invoice.registeredUsersList

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const result = yield call(apiManualPost, url, body)
    const invoiceResult = JSON.parse(result.data)
    const creditNoteFromInvoice =
      invoiceResult[0].Invoice[0].credit_note_from_invoice

    invoiceResult[0].Invoice[0].rows = convertCostsToi18next(
      invoiceResult[0].Invoice[0].rows
    )

    if (invoiceResult[0].Invoice[0].is_group_invoice === 1) {
      invoiceResult[0].Invoice[0].groupInvoiceRow =
        convertGroupInvoiceRowValues(
          invoiceResult[0].Invoice[0].groupInvoiceRow,
          registeredUsersList
        )
    }

    if (result.data) {
      yield put(getInvoiceByIdSuccess(result.data))
      if (creditNoteFromInvoice && creditNoteFromInvoice > 1) {
        yield put(setOriginalInvoiceId(creditNoteFromInvoice))
      }
    }

    let expenseRows = []
    if (expenses?.expense?.length > 0) {
      const urlAddExp = `${API_SERVER}/AddExpensesToInvoice`
      const bodyAddExp = JSON.stringify({
        invoice_expense_ids: expenses.expense
      })
      const expResult = yield call(apiManualPost, urlAddExp, bodyAddExp)
      const parsedResults = JSON.parse(expResult.data)
      expenseRows = convertCostsToi18next(parsedResults)
    }

    let allowanceRows = []
    if (expenses?.allowance?.length > 0) {
      const urlAddAllows = `${API_SERVER}/AddAllowanceToInvoice`
      const bodyAddAllows = JSON.stringify({
        invoice_allowance_ids: expenses.allowance
      })
      const allResult = yield call(apiManualPost, urlAddAllows, bodyAddAllows)
      allowanceRows = JSON.parse(allResult.data)
    }

    let expenseAllowanceRows = expenseRows.concat(allowanceRows)
    let invoiceRows = invoiceResult[0].Invoice[0].rows
    let allRows = invoiceRows.concat(expenseAllowanceRows)
    const normalInvoiceRow = allRows.filter(
      (el) => el.invoice_expense_id === -1 && el.invoice_allowance_id === -1
    )

    const formData = getFormData(invoiceResult, allRows)
    formData.vat_selection =
      formData.vat_select === 'vat_25_5_common'
        ? 25.5
        : formData.vat_select === 'vat_24_common'
        ? 24
        : formData.vat_select === 'vat_0_builders'
        ? 'building_service'
        : formData.vat_select === 'vat_14_restaurants'
        ? 14
        : formData.vat_select === 'vat_10_sports'
        ? 10
        : formData.vat_select === 'vat_0_artists'
        ? 0
        : formData.vat_select === 'vat_0_abroad'
        ? 'vat_abroad'
        : normalInvoiceRow[0].vat_percent

    if (creditNoteFromInvoice && creditNoteFromInvoice > 1) {
      formData.is_credit_note = true
    }

    if (invoiceResult[0].Invoice[0].is_group_invoice === 1) {
      formData.groupInvoice = true
    }

    if (invoiceResult[0].Invoice[0]?.workshift_journal_id) {
      formData.addWorkshiftJournal = true
      const selectedJournalIds = stringToArray(
        invoiceResult[0].Invoice[0].workshift_journal_id
      )
      formData.attachedJournalIds = selectedJournalIds

      yield put(attachWorkshiftJournalIdSuccess(selectedJournalIds))
    }

    if (invoiceResult[0].Invoice[0].is_group_invoice === 0) {
      formData.groupInvoiceRow = groupInvoiceRowDefaultValue
    }

    yield put(updateFormValues('invoice', formData))
    yield put(closeLoadInvoiceItems())
  } catch (e) {
    yield put(closeLoadInvoiceItems())
    // console.warn(e)
  }
}

function* invoiceLocationChangeSaga() {
  try {
    const pathname = store.getState().router.location.pathname
    const prevPath = store.getState().routerLocations.prevLocation.pathname
    // let invoiceEdit = []
    // invoiceEdit = store.getState().invoice.invoiceEdit
    let isEdit = false
    isEdit = store.getState().invoice.isEdit
    const preventCancelInvoice = store.getState().invoice.preventCancelInvoice
    const enableExpenseBackBtn =
      store.getState().invoice.enable_expense_back_btn
    const enableAllowanceBackBtn =
      store.getState().invoice.enable_allowance_back_btn

    if (pathname === '/dashboard/invoice/review' || preventCancelInvoice) {
      //console.log('Need not to clear the invoice form..........')
    } else if (
      pathname === '/dashboard/fee' ||
      pathname === '/dashboard/invoice' ||
      pathname === '/dashboard/fee/newfee' ||
      pathname === '/dashboard/fee/newallowance'
    ) {
      if (prevPath === '/dashboard/invoice' && pathname === '/dashboard/fee') {
        yield put(cancelEditInvoice())
      } else if (
        !(pathname === prevPath && prevPath === '/dashboard/invoice') &&
        !(
          ((enableExpenseBackBtn || enableAllowanceBackBtn) &&
            pathname === '/dashboard/fee/newfee') ||
          pathname === '/dashboard/fee/newallowance'
        )
      ) {
        yield put(cancelEditInvoice())
        if (pathname === '/dashboard/invoice') {
          scrollToTop()
        }
      }
    } else if (isEdit === true) {
      yield put(cancelEditInvoice())
    }
  } catch (e) {
    // console.warn(e)
  }
}

function* copyInvoiceSaga({ invoice_id }) {
  try {
    const invoiceUrl = `${API_SERVER}/CopyInvoiceByInvoiceID`
    const uuid = store.getState().client.user.data[2]

    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_id: invoice_id,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    //api calls for invoice data
    const result = yield call(apiManualPost, invoiceUrl, body)

    if (result.data) {
      yield put(copyInvoiceSuccess(result.data))

      yield put(loadInvoiceItems())
    }

    const invoiceResult = JSON.parse(result.data)
    const formData = getFormData(
      invoiceResult,
      invoiceResult[0].Invoice[0].rows
    )

    const normalInvoiceRow = formData.rows.filter(
      (el) => el.invoice_expense_id === -1 && el.invoice_allowance_id === -1
    )
    formData.vat_selection =
      formData.vat_select === 'vat_25_5_common'
        ? 25.5
        : formData.vat_select === 'vat_24_common'
        ? 24
        : formData.vat_select === 'vat_0_builders'
        ? 'building_service'
        : formData.vat_select === 'vat_14_restaurants'
        ? 14
        : formData.vat_select === 'vat_10_sports'
        ? 10
        : formData.vat_select === 'vat_0_artists'
        ? 0
        : formData.vat_select === 'vat_0_abroad'
        ? 'vat_abroad'
        : normalInvoiceRow[0].vat_percent

    if (invoiceResult[0].Invoice[0].is_group_invoice === 0) {
      formData.groupInvoiceRow = groupInvoiceRowDefaultValue
    }

    yield put(updateFormValues('invoice', formData))

    yield put(getInvoicesStart())
    yield put(closeLoadInvoiceItems())
  } catch (e) {
    // console.warn(e)
  }
}

function getFormData(result, rows) {
  const { Invoice, ...customerInfo } = result[0]
  const formData = {
    ...customerInfo,
    ...Invoice[0]
  }

  formData.quick_pay = formData.instant_payment === 'quick_pay' ? true : false
  formData.invoice_reminder =
    formData.is_payment_control === false ? true : false

  formData.billing_date = new Date()
  formData.due_date = new Date()
  formData.due_date.setDate(formData.billing_date.getDate() + formData.overdue)
  formData.invoice_lang = formData.invoice_lang === 'en' ? true : false

  if (rows.length === 0 || (rows.length === 1 && isEmpty(rows[0]))) {
    formData.rows = [{ ...invoiceRowDefaultValues }]
    formData.rows[0].vat_percent =
      formData.vat_select === 'vat_25_5_common'
        ? 25.5
        : formData.vat_select === 'vat_24_common'
        ? 24
        : formData.vat_select === 'vat_0_builders'
        ? 'building_service'
        : formData.vat_select === 'vat_14_restaurants'
        ? 14
        : formData.vat_select === 'vat_10_sports'
        ? 10
        : formData.vat_select === 'vat_0_artists'
        ? 0
        : formData.vat_select === 'vat_0_abroad'
        ? 'vat_abroad'
        : 24
    if (formData.vat_select === 'building_service') {
      formData.rows[0].vat_percent = 0
    }
    formData.total_sum = 0
  } else {
    formData.rows = rows
    formData.rows.forEach((row, index, rows) => {
      rows[index].sum_with_vat =
        // KAS-356 When invoice row is expense, don't need to calculate the sumWithVAT
        // calculation expense sumWithVAT is done at Costs and expenses tab
        rows[index].invoice_expense_id !== -1
          ? rows[index].sum_tax_free + rows[index].vat
          : calculateTotalSum(
              formData.invoice_price_selection,
              row.quantity,
              row.quantity_price,
              row.vat_percent,
              row.invoice_expense_id.toString() !== '-1'
            )
      rows[index].start_date = new Date(rows[index].start_date)
      rows[index].end_date = new Date(rows[index].end_date)
    })
  }

  return formData
}

function* cancelEditInvoiceSaga() {
  try {
    yield put(resetForm('invoice'))
    yield put(getInvoiceUserEmail(0))
  } catch (e) {
    // console.warn(e)
  }
}

function* getFinvoiceOperatorsSaga() {
  try {
    const url = `${API_SERVER}/GetFinInvoiceOperators`
    const result = yield apiManualRequest(url)
    const parRes = JSON.parse(result.data)
    const parsedResult = propertyArray(parRes, 'operator_name')
    if (parsedResult) yield put(getOperatorSuccess(parsedResult))
  } catch (e) {
    yield put(getOperatorFailed(e))
  }
}

function* addExpensesToInvoiceSaga({ expenses, formValues }) {
  try {
    yield put(loadInvoiceItems())

    const url = `${API_SERVER}/AddExpensesToInvoice`
    const body = JSON.stringify({ invoice_expense_ids: expenses })
    const response = yield call(apiManualPost, url, body)
    const expenseRows = JSON.parse(response.data)

    for (let i = 0; i < expenseRows.length; i++) {
      expenseRows[i].start_date = new Date(expenseRows[i].start_date)
      expenseRows[i].end_date = new Date(expenseRows[i].end_date)
      expenseRows[i].description = convertCostsToi18next(expenseRows[i])
    }

    let newFormValues = {}
    if (!formValues) {
      newFormValues = { ...defaultValues }
      newFormValues.rows = []
    } else {
      newFormValues = { ...formValues }
    }

    newFormValues.rows = [...newFormValues.rows, ...expenseRows]
    newFormValues.addCost = false

    yield put(updateFormValues('invoice', newFormValues))
    yield put(closeLoadInvoiceItems())
  } catch (e) {
    // console.log(e)
    yield put(closeLoadInvoiceItems())
  }
}

function* addAllowancesToInvoiceSaga({ allowances, formValues }) {
  try {
    yield put(loadInvoiceItems())

    const url1 = `${API_SERVER}/AddAllowanceToInvoice`
    const body1 = JSON.stringify({ invoice_allowance_ids: allowances })
    const response = yield call(apiManualPost, url1, body1)
    const allowanceRows = JSON.parse(response.data)

    for (let i = 0; i < allowanceRows.length; i++) {
      allowanceRows[i].start_date = new Date(allowanceRows[i].start_date)
      allowanceRows[i].end_date = new Date(allowanceRows[i].end_date)
    }

    let newFormValues = {}
    if (!formValues) {
      newFormValues = { ...defaultValues }
      newFormValues.rows = []
    } else {
      newFormValues = { ...formValues }
    }

    newFormValues.rows = [...newFormValues.rows, ...allowanceRows]
    newFormValues.addAllowance = false

    yield put(updateFormValues('invoice', newFormValues))
    yield put(closeLoadInvoiceItems())
  } catch (e) {
    // console.log(e)
  }
}

function* changeVATPercentSaga({ value, fields }) {
  try {
    const occurences = fields.length
    const vatChanges = []
    if (value === 'building_service' || value === 'vat_abroad') {
      for (let i = 0; i < occurences; i++) {
        if (
          fields[i].invoice_allowance_id == -1 &&
          fields[i].invoice_expense_id == -1
        ) {
          vatChanges.push({ field: `rows.${i}.vat_percent`, value: 0 })
        }
      }
    } else {
      for (let i = 0; i < occurences; i++) {
        if (
          fields[i].invoice_allowance_id == -1 &&
          fields[i].invoice_expense_id == -1
        ) {
          vatChanges.push({ field: `rows.${i}.vat_percent`, value: value })
        }
      }
    }
    yield put(setFieldValue('invoice', vatChanges))
  } catch (e) {
    // console.log('Failed to update vat percents')
  }
}

function* navigateToUpdateBankInfoSaga({ formValues }) {
  //GetProfessions
  const professionUrl = `${API_SERVER}/GetProffession`
  const professionResult = yield apiManualRequest(professionUrl)
  const profRes = JSON.parse(professionResult.data)
  const parsedProfResult = propertyArray(profRes, 'profession')
  if (parsedProfResult) {
    yield put(getProfessionSuccess(parsedProfResult))
  } else getProfessionFailed(profRes)

  //LoadProfile
  const uuid = store.getState().client.user.data[2]
  const userType = store.getState().client.user.data[5]
  const { adminUser } = store.getState()
  const { selectedUser } = adminUser

  if (!!uuid) {
    const detailsUrl = `${API_SERVER}/GetUserContactDetails`
    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })
    const result = yield call(apiManualPost, detailsUrl, body)
    const resultParsed = JSON.parse(result.data)
    yield put(loadProfileSuccess(resultParsed))
  }
  yield put(saveInvoiceDraft(formValues))
  yield put(closeInvoiceReviewSnackBar())
  yield put(push('/dashboard/profile'))
}

function* selectInvoiceCustomerSaga({ customer, formValues }) {
  const values = { ...defaultValues, ...formValues, ...customer }
  values.rows = formValues.rows
  if (values.country !== 1 || values.customer_type === 'private_person') {
    values.quick_pay = false
  }
  yield put(updateFormValues('invoice', values))
}

function* editAndGoToInvoiceSaga({ formValues }) {
  yield put(removeInvoiceAttachments())
  yield put(goToInvoice())
  yield put(loadInvoiceItems())
  yield delay(100)
  const editValues = {
    ...defaultValues,
    ...formValues
  }
  yield put(updateFormValues('invoice', editValues))
  yield put(closeLoadInvoiceItems())
}

function* goToInvoiceSaga() {
  yield put(push('/dashboard/invoice'))
  yield put(showInvoiceFormDialog())
}

function* getRegisteredUsersSaga({ email }) {
  try {
    const registeredUsersList = yield select(getRegisteredUsersList)
    if (!registeredUsersList.some((obj) => obj.email === email)) {
      const url = `${API_SERVER}/GetRegisteredUsers`
      const body = JSON.stringify({
        email: email
      })
      const result = yield apiManualPost(url, body)
      const resultParsed = JSON.parse(result.data)

      if (result.data) {
        yield put(getRegisteredUsersListSuccess(resultParsed))
      }
    }
  } catch (e) {
    yield put(getRegisteredUsersListFailed(e))
  }
}

function* getInvoiceUserEmailSaga({ i, data }) {
  try {
    let userEmail
    let userUuid
    if (data && data.email && data.uuid) {
      userEmail = data.email
      userUuid = data.uuid
    } else {
      const userType = yield select(getUserType)
      const selectedUser = store.getState().adminUser?.selectedUser
      const loggedInUserEmail = yield select(getLoggedInEmail)
      const uuid = yield select(getUuid)
      userEmail = userType === 2 ? selectedUser?.email : loggedInUserEmail
      userUuid = userType === 2 ? selectedUser?.uuid : uuid
    }

    const loggedInUser = { email: userEmail, uuid: userUuid }

    yield put(
      setFieldValue('invoice', {
        field: `groupInvoiceRow.${i}.groupEmail`,
        value: userEmail
      })
    )
    yield put(getRegisteredUsersListSuccess(loggedInUser))
  } catch (e) {
    console.log('Failed to update email', e)
  }
}

function* attachedWorkShiftJournalIdSaga({ journal_id }) {
  try {
    const attachedWorkShiftJournalIds = yield select(
      getAttachedWorkShiftJournalIds
    )
    let selectedIds
    if (attachedWorkShiftJournalIds.includes(journal_id)) {
      // If already selected, remove it from the array
      selectedIds = attachedWorkShiftJournalIds.filter(
        (id) => id !== journal_id
      )
    } else {
      // If not selected, add it to the array
      selectedIds = [...attachedWorkShiftJournalIds, journal_id]
    }
    yield put(attachWorkshiftJournalIdSuccess(selectedIds))
  } catch (error) {
    console.log(error)
  }
}

function* updateAttachJournalToInvoiceSaga({
  journal_id,
  invoice_id,
  attachOption
}) {
  try {
    const url = `${API_SERVER}/UpdateUserWorkShiftJournalDetails`
    const uuid = yield select(getUuid)
    const userType = yield select(getUserType)
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      workshiftjournals: [
        {
          journalid: journal_id,
          Invoice: [
            {
              invoice_id: invoice_id
            }
          ],
          attachOption: attachOption
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)

    if (
      result.data === 'Added work shift journal to invoice successfully' ||
      result.data === 'Detached work shift journal from invoice successfully'
    ) {
      yield put(updateAttachJournalToInvoiceSuccess(result.data))
    } else {
      yield put(updateAttachJournalToInvoiceFailed(error))
    }
  } catch (error) {
    yield put(updateAttachJournalToInvoiceFailed(error))
  }
}

export function* watchGetInvoiceSaga() {
  yield takeEvery(GET_INVOICES_START, getInvoiceSaga)
}

export function* watchSaveAndSendInvoiceSaga() {
  yield takeEvery(SAVE_AND_SEND_INVOICE, saveAndSendInvoiceSaga)
}

export function* watchRemoveInvoiceSaga() {
  yield takeEvery(REMOVE_INVOICE, removeInvoiceSaga)
}

export function* watchCopyInvoice() {
  yield takeEvery(COPY_INVOICE, copyInvoiceSaga)
}

export function* watchSaveInvoiceDraft() {
  yield takeEvery(SAVE_INVOICE_DRAFT, saveInvoiceDraftSaga)
}

export function* watchEditInvoice() {
  yield takeEvery(EDIT_INVOICE, editInvoiceSaga)
}

export function* watchCancelEditInvoice() {
  yield takeEvery(CANCEL_EDIT_INVOICE, cancelEditInvoiceSaga)
}

export function* watchGenerateInvoicePDF() {
  yield takeEvery(GENERATE_INVOICE_PDF, generateInvoicePDF)
}

export function* watchSaveAndSendInvoicePDF() {
  yield takeEvery(SAVE_AND_SEND_INVOICE_PDF, saveAndSendInvoicePDF)
}

export function* watchInvoiceDownloadPDF() {
  yield takeEvery(INVOICE_DOWNLOAD_PDF, invoiceDownloadPDF)
}

export function* watchFinvoiceOperators() {
  yield takeEvery(GET_FINVOICE_OPERATOR, getFinvoiceOperatorsSaga)
}

export function* watchInvoiceLocationChangeSaga() {
  yield takeEvery(LOCATION_CHANGE, invoiceLocationChangeSaga)
}

export function* watchNavigateToUpdateBankInfoSaga() {
  yield takeEvery(NAVIGATE_TO_UPDATE_BANK_INFO, navigateToUpdateBankInfoSaga)
}

export function* watchReminderInvoiceDownloadPDFSaga() {
  yield takeEvery(REMINDER_INVOICE_DOWNLOAD_PDF, reminderInvoiceDownloadPDF)
}

export function* watchChangeVATPercentSaga() {
  yield takeEvery(CHANGE_VAT_PERCENT, changeVATPercentSaga)
}

export function* watchSelectInvoiceCustomerSaga() {
  yield takeEvery(SELECT_INVOICE_CUSTOMER, selectInvoiceCustomerSaga)
}

export function* watchEditAndGoToInvoiceSaga() {
  yield takeEvery(EDIT_AND_GO_TO_INVOICE, editAndGoToInvoiceSaga)
}

export function* watchGoToInvoiceSaga() {
  yield takeEvery(GO_TO_INVOICE, goToInvoiceSaga)
}

export function* watchAddExpensesToInvoiceSaga() {
  yield takeEvery(ADD_EXPENSES_TO_INVOICE, addExpensesToInvoiceSaga)
}

export function* watchAddAllowancesToInvoiceSaga() {
  yield takeEvery(ADD_ALLOWANCES_TO_INVOICE, addAllowancesToInvoiceSaga)
}

export function* watchAddCreditNoteInvoice() {
  yield takeEvery(ADD_CREDIT_NOTE_INVOICE, addCreditNoteInvoice)
}

export function* watchGetRegisteredUsersListSaga() {
  yield takeEvery(GET_REGISTERED_USERS_LIST, getRegisteredUsersSaga)
}

export function* watchGetInvoiceUserEmailSaga() {
  yield takeEvery(GET_INVOICE_USER_EMAIL, getInvoiceUserEmailSaga)
}
export function* watchAttachedWorkShiftJournalIdSaga() {
  yield takeEvery(ATTACH_WORKSHIFT_JOURNAL_ID, attachedWorkShiftJournalIdSaga)
}
export function* watchUpdateAttachJournalToInvoiceSaga() {
  yield takeEvery(
    UPDATE_ATTACH_JOURNAL_TO_INVOICE,
    updateAttachJournalToInvoiceSaga
  )
}
